<ol class="flex flex-row flex-wrap items-stretch gap-3">
  @for (step of steps(); track step.key) {
    <li
      class="flex min-h-[5.75rem] flex-1 items-start gap-2.5 rounded-2xl border px-4 py-3 transition-colors"
      [attr.aria-current]="step.isActive ? 'step' : null"
      [class.bg-primary-background]="step.isActive"
      [class.shadow-md]="step.isActive"
      [class.border-primary-border]="step.isActive"
      [class.bg-secondary-background]="step.isCompleted"
      [class.bg-white]="step.isUpcoming"
      [class.border-secondary-border]="step.isUpcoming"
      [class.border-dashed]="step.isUpcoming"
      [class.opacity-80]="step.isUpcoming"
    >
      <span
        class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-sm font-semibold"
        [class.bg-white]="step.isActive"
        [class.border-primary-border]="step.isActive"
        [class.text-primary-text]="step.isActive || step.isCompleted"
        [class.bg-primary-background]="step.isCompleted"
        [class.border-secondary-border]="step.isUpcoming"
        [class.text-secondary-text]="step.isUpcoming"
      >
        @if (step.isCompleted) {
          <span aria-hidden="true">✓</span>
        } @else {
          {{ step.number }}
        }
      </span>

      <span class="min-w-0">
        <span
          class="mb-1.5 inline-flex w-fit rounded-full border px-2 py-0.5 text-[10px] font-semibold tracking-[0.16em] whitespace-nowrap uppercase"
          [class.bg-white]="step.isActive"
          [class.border-primary-border]="step.isActive"
          [class.text-primary-text]="step.isActive || step.isCompleted"
          [class.bg-primary-background]="step.isCompleted"
          [class.border-secondary-border]="step.isUpcoming"
          [class.text-secondary-text]="step.isUpcoming"
        >
          {{ step.statusKey | translate }}
        </span>
        <span
          class="block text-sm leading-snug font-semibold"
          [class.text-primary-text]="step.isActive || step.isCompleted"
          [class.text-secondary-text]="step.isUpcoming"
        >
          {{ step.key | translate }}
        </span>
      </span>
    </li>
  }
</ol>
